export const TABLIST = {
  USER_PROFILE: "USER_PROFILE",
  VITALS: "VITALS",
  SLEEP: "SLEEP",
  ACTIVITY: "ACTIVITY",
  CALORIES_BALANCE: "CALORIES_BALANCE",
  STRESS: "STRESS",
  VO2MAX: "VO2MAX",
};

export const TABLIST_TEXT_MAPPING = {
  [TABLIST.USER_PROFILE]: "User profile",
  [TABLIST.VITALS]: "Vitals",
  [TABLIST.SLEEP]: "Sleep",
  [TABLIST.ACTIVITY]: "Activity",
  [TABLIST.CALORIES_BALANCE]: "Calorie balance",
  [TABLIST.STRESS]: "Stress",
  [TABLIST.VO2MAX]: "VO2 Max",
};

export const COACH_REFERENCE_DOC =
  "https://docs.google.com/document/d/1R-bgKhfPk7xwHZImxSAd4IbRFwhbR08jsCsclIdCx5I/edit#heading=h.ofna7muw6cpi";

export const TABLIST_ARRAY = [
  TABLIST.USER_PROFILE,
  TABLIST.VITALS,
  TABLIST.VO2MAX,
  TABLIST.SLEEP,
  TABLIST.ACTIVITY,
  TABLIST.CALORIES_BALANCE,
  TABLIST.STRESS,
];

export const CHART_VIEW_TYPES = {
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTHLY",
};

export const CHART_VIEW_TYPES_TEXT_MAPPING: any = {
  WEEKLY: "Weekly",
  MONTHLY: "Monthly",
};

export const USER_METRICS_UNIT_MAPPING = {
  HEART_RATE: "bpm",
  CALORIES: "kcal",
  VO2MAX: "ml/(kg·min)",
  TIME: " h/min",
};
